import { FileQuestion } from 'lucide-react'
import { useTranslation } from 'react-i18next'

import { ErrorPageLayout } from './ErrorPageLayout'

/** C6 — 404. Router'ın `notFoundComponent`'i bunu `app/NotFound.tsx` üzerinden çizer. */
export function NotFoundPage() {
  const { t } = useTranslation()

  return (
    <ErrorPageLayout
      code="404"
      icon={<FileQuestion />}
      title={t('errors.notFound.title')}
      description={t('errors.notFound.description')}
    />
  )
}
